const ratingValues = {
  STRONG: 3,
  OK: 2,
  WEAK: 1,
  NO: 0
}

const ratingOptions = {
  [ratingValues.STRONG]: {
    label: 'Strong',
    imgUrl: require('../assets/svg/ratings/star.svg')
  },
  [ratingValues.OK]: {
    label: 'OK',
    imgUrl: require('../assets/svg/ratings/check.svg'),
    value: 2
  },
  [ratingValues.WEAK]: {
    label: 'Weak',
    imgUrl: require('../assets/svg/ratings/oblique.svg'),
    value: 1
  },
  [ratingValues.NO]: {
    label: 'No',
    imgUrl: require('../assets/svg/ratings/cross.svg'),
    value: 0
  }
}

export { ratingValues, ratingOptions }
